/* DUVI — comportamento das seções da home + Comprar rápido (todas as páginas) */
(() => {
  'use strict';

  const CFG = window.DUVI || {};
  const ROOT = CFG.root || '';          // '' dentro do tema; URL da loja na landing externa
  const EXTERNAL = !!CFG.external;      // landing fora do domínio da loja: carrinho via link
  const UTM = CFG.utm || '';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || CFG.currency || 'BRL';
  const money = (cents) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency }).format((cents || 0) / 100);
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const withUtm = (url, content) => {
    if (!UTM) return url;
    const u = new URL(url, location.href);
    new URLSearchParams(UTM).forEach((v, k) => u.searchParams.set(k, v));
    if (content) u.searchParams.set('utm_content', content);
    return u.toString();
  };
  const imgW = (src, w) => {
    if (!src) return '';
    if (src.startsWith('//')) src = 'https:' + src;   // protocol-relative CDN URLs from /products/*.js
    try {
      const u = new URL(src, location.href);
      u.searchParams.set('width', w);
      return u.toString();
    } catch (e) { return src; }
  };

  const COLOR_HEX = {
    'Preta': '#121212', 'Preto': '#121212', 'Branca': '#F5F5F3', 'Branco': '#F5F5F3', 'Off-White': '#ECE6D8',
    'Caramelo': '#C68A55', 'Verde Musgo': '#7D7F57', 'Marrom': '#5B4032', 'Chocolate': '#4A3026', 'Verde Militar': '#4E5634',
    'Amarela': '#F2C94C', 'Azul Marinho': '#1F2A44', 'Azul Royal': '#2747C9', 'Azul Claro': '#8EC5FF', 'Cinza': '#A7A8AC',
    'Cinza Chumbo': '#4A4D52', 'Rosa Pink': '#E83E8C', 'Rosa Bebê': '#F4C2D7', 'Rosa Claro': '#F7CFD8', 'Roxo': '#6B3FA0',
    'Verde Bandeira': '#11823B', 'Verde Limão': '#9BE33F', 'Verde Escuro': '#1F4D2B', 'Vermelho Intenso': '#C21E2B',
    'Laranja': '#F07A22', 'Vinho': '#6E1A2C', 'Natural': '#D9C7A7', 'Tabaco': '#7A4E2D'
  };
  const isColorOption = (name) => /^(cor|cores|color|colour)$/i.test(String(name).trim());
  const SIZE_ORDER = ['RN', 'PP', 'P', 'M', 'G', 'GG', 'EG', 'XG', 'EGG', 'XGG', 'G1', 'G2', 'G3', 'G4'];
  const sizeRank = (v) => { const i = SIZE_ORDER.indexOf(String(v).trim().toUpperCase()); return i < 0 ? 99 : i; };
  const sortValues = (name, values) => (/^(tamanho|tamanhos|size|tam)$/i.test(String(name).trim()) ? values.slice().sort((a, b) => sizeRank(a) - sizeRank(b)) : values);

  // "Oversized Essential - Offline Mode (Técnica DTG)" -> { name, line, tech, gsm }
  const parseTitle = (title, type) => {
    let t = String(title).replace(/\s+/g, ' ');
    const tech = (t.match(/T[ée]cnica\s+(DTG|DFT)/i) || [])[1];
    t = t.replace(/\(\s*T[ée]cnica[^)]*\)+/i, '').trim();
    const parts = t.split(/\s+[–-]\s+/);
    const name = parts.length > 1 ? parts.slice(1).join(' – ') : t;
    const line = parts.length > 1 ? parts[0] : (type || '');
    const gsm = (line.match(/(\d{3})\s*g?/) || [])[1];
    return { name, line, tech: tech && tech.toUpperCase(), gsm };
  };

  const ICON_BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/><path d="M12 12v4M10 14h4"/></svg>';
  const ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  const ICON_RULER = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 15.5 15.5 3 21 8.5 8.5 21z"/><path d="M7 12l2 2M10 9l2 2M13 6l2 2"/></svg>';
  const triggerHTML = (handle, name) =>
    `<button type="button" class="d-qb-trigger" data-qb="${esc(handle)}" aria-label="Comprar rápido: ${esc(name || handle)}">${ICON_BAG}<span>Comprar rápido</span></button>`;

  /* ================= Guia de medidas ================= */
  // Dados em snippets/duvi-size-guides.liquid (window.DUVI.sizeGuides); cada guia casa com o título do produto
  const SG = (() => {
    const guides = Array.isArray(CFG.sizeGuides) ? CFG.sizeGuides : [];
    const find = (title) => {
      const t = String(title || '').toLowerCase();
      return guides.find((g) => (g.match || []).some((m) => t.includes(String(m).toLowerCase()))) || null;
    };
    const table = (g, active) => `<table class="d-sg__table">
        <thead><tr><th scope="col">Tamanho</th><th scope="col">Altura</th><th scope="col">Largura</th></tr></thead>
        <tbody>${g.rows.map((r) => `<tr${r[0] === active ? ' class="is-active"' : ''}><th scope="row">${esc(r[0])}</th><td>${esc(r[1])}</td><td>${esc(r[2])}</td></tr>`).join('')}</tbody>
      </table>`;
    const NOTE = '<p class="d-sg__note">Medidas da peça em centímetros, com margem de tolerância de fabricação. Dica: meça uma camiseta sua que veste bem e compare.</p>';
    const HOW = `<div class="d-sg__how">
        <svg viewBox="0 0 120 110" aria-hidden="true"><path d="M38 8 20 14 4 34l14 12 10-8v64h64V38l10 8 14-12-16-20-18-6c-3 7-11 12-22 12S41 15 38 8z" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linejoin="round"/><path d="M30 46h60" stroke="var(--d-accent-2)" stroke-width="2.5" stroke-dasharray="4 4"/><path d="M100 22v80" stroke="var(--d-accent)" stroke-width="2.5" stroke-dasharray="4 4"/></svg>
        <ul><li><b style="color:var(--d-accent)">Altura</b> do ponto mais alto do ombro até a barra.</li><li><b style="color:var(--d-accent-2)">Largura</b> de uma axila à outra, com a peça esticada.</li></ul>
      </div>`;

    let dlg = null;
    const open = (title, active) => {
      const g = find(title);
      if (!g) return;
      if (!dlg) {
        dlg = document.createElement('div');
        dlg.className = 'd-qb d-sg';
        dlg.hidden = true;
        document.body.appendChild(dlg);
        dlg.addEventListener('click', (e) => { if (e.target.closest('[data-sg-close]')) close(); });
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !dlg.hidden) close(); });
      }
      dlg.innerHTML = `<div class="d-qb__overlay" data-sg-close></div>
        <div class="d-qb__panel d-sg__panel" role="dialog" aria-modal="true" aria-labelledby="d-sg-title">
          <button type="button" class="d-qb__close" data-sg-close aria-label="Fechar">${ICON_X}</button>
          <span class="d-qb__line">Guia de medidas</span>
          <h2 class="d-qb__title" id="d-sg-title">${esc(g.name)}</h2>
          ${table(g, active)}${HOW}${NOTE}
        </div>`;
      dlg.hidden = false;
      document.documentElement.classList.add('d-qb-open');
      const c = $('.d-qb__close', dlg); c && c.focus();
    };
    const close = () => {
      if (!dlg) return;
      dlg.hidden = true;
      document.documentElement.classList.remove('d-qb-open');
    };

    // Página de produto: bloco "Liquid personalizado" com <div class="d-sg-slot" data-sg-title="...">
    const mount = (scope) => {
      $$('.d-sg-slot', scope).forEach((slot) => {
        if (slot.dataset.ready || !find(slot.dataset.sgTitle)) return;
        slot.dataset.ready = '1';
        slot.innerHTML = `<button type="button" class="d-sg-btn" data-sg-open>${ICON_RULER}<span>Guia de medidas</span></button>`;
      });
    };
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-sg-open]');
      if (!b) return;
      const slot = b.closest('.d-sg-slot');
      const form = b.closest('.product__info-wrapper, .product') || document;
      const sizes = $$('variant-selects input[type="radio"]:checked, variant-selects select option:checked', form).map((x) => x.value);
      const g = find(slot && slot.dataset.sgTitle);
      const active = g && g.rows.map((r) => r[0]).find((s) => sizes.includes(s));
      open(slot && slot.dataset.sgTitle, active);
    });

    return { find, table, NOTE, open, mount };
  })();
  window.DUVISizeGuide = SG;
  SG.mount(document);
  document.addEventListener('shopify:section:load', (e) => SG.mount(e.target));

  /* ================= Comprar rápido ================= */
  const QB = (() => {
    const cache = new Map();
    let el = null, body = null, state = null, lastFocus = null;

    const ensure = () => {
      if (el) return;
      el = document.createElement('div');
      el.className = 'd-qb';
      el.hidden = true;
      el.innerHTML = `<div class="d-qb__overlay" data-qb-close></div>
        <div class="d-qb__panel" role="dialog" aria-modal="true" aria-labelledby="d-qb-title">
          <button type="button" class="d-qb__close" data-qb-close aria-label="Fechar">${ICON_X}</button>
          <div class="d-qb__body" style="display:contents"></div>
        </div>`;
      document.body.appendChild(el);
      body = $('.d-qb__body', el);
      el.addEventListener('click', (e) => {
        if (e.target.closest('[data-qb-close]')) return close();
        const opt = e.target.closest('[data-opt]');
        if (opt) return choose(+opt.dataset.opt, opt.dataset.val);
        const th = e.target.closest('[data-thumb]');
        if (th) { state.img = th.dataset.thumb; return draw(); }
        if (e.target.closest('[data-sg-toggle]')) { state.sg = !state.sg; return draw(); }
        const step = e.target.closest('[data-qty]');
        if (step) { state.qty = Math.max(1, Math.min(99, state.qty + +step.dataset.qty)); return draw(); }
        if (e.target.closest('[data-qb-add]')) add();
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && el && !el.hidden) close(); });
    };

    const load = async (handle) => {
      if (cache.has(handle)) return cache.get(handle);
      const r = await fetch(`${ROOT}/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
      if (!r.ok) throw new Error('HTTP ' + r.status);
      const p = await r.json();
      cache.set(handle, p);
      return p;
    };

    const open = async (handle, trigger) => {
      ensure();
      lastFocus = trigger || document.activeElement;
      body.innerHTML = '<div class="d-qb__skel"><span class="d-qb__spin" aria-label="Carregando"></span></div>';
      el.hidden = false;
      document.documentElement.classList.add('d-qb-open');
      try {
        const p = await load(handle);
        const first = p.variants.find((v) => v.available) || p.variants[0];
        state = { p, sel: first.options.slice(), qty: 1, img: null, busy: false, msg: '', ok: false };
        draw();
        const c = $('.d-qb__close', el); c && c.focus();
      } catch (e) {
        location.href = withUtm(`${ROOT}/products/${handle}`, 'quick-buy');
      }
    };

    const close = () => {
      if (!el) return;
      el.hidden = true;
      document.documentElement.classList.remove('d-qb-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    const match = (sel) => state.p.variants.find((v) => v.options.every((o, i) => o === sel[i]));
    const current = () => match(state.sel);
    const valueState = (i, val) => {
      const sel = state.sel.slice(); sel[i] = val;
      const v = match(sel);
      return v ? (v.available ? 'ok' : 'out') : 'none';
    };

    const choose = (i, val) => {
      state.sel[i] = val;
      const v = current();
      if (!v || !v.available) {
        // keep the clicked value and pick the closest available combination
        const alt = state.p.variants.find((x) => x.available && x.options[i] === val);
        if (alt) state.sel = alt.options.slice();
      }
      state.msg = ''; state.ok = false;
      const nv = current();
      if (nv && nv.featured_image && nv.featured_image.src) state.img = nv.featured_image.src;
      draw();
    };

    const draw = () => {
      const { p } = state;
      const v = current();
      const { name, line, tech } = parseTitle(p.title, p.type);
      const img = state.img || (v && v.featured_image && v.featured_image.src) || p.featured_image || p.images[0];
      const price = v ? v.price : p.price_min;
      const cmp = v ? v.compare_at_price : 0;
      const single = p.variants.length === 1 && /default title/i.test(p.variants[0].title);
      const guide = SG.find(p.title);
      const opts = single ? '' : p.options.map((o, i) => {
        const color = isColorOption(o.name);
        const sizeOpt = guide && /^(tamanho|tamanhos|size|tam)$/i.test(String(o.name).trim());
        const vals = sortValues(o.name, o.values).map((val) => {
          const st = valueState(i, val);
          if (st === 'none') return '';
          const pressed = state.sel[i] === val;
          const cls = st === 'out' ? ' is-out' : '';
          if (color && COLOR_HEX[val]) {
            return `<button type="button" class="d-qb__sw${cls}" style="background:${COLOR_HEX[val]}" data-opt="${i}" data-val="${esc(val)}" aria-pressed="${pressed}" aria-label="${esc(val)}${st === 'out' ? ' (esgotado)' : ''}" title="${esc(val)}"></button>`;
          }
          return `<button type="button" class="d-qb__pill${cls}" data-opt="${i}" data-val="${esc(val)}" aria-pressed="${pressed}">${esc(val)}</button>`;
        }).join('');
        const sgBtn = sizeOpt ? `<button type="button" class="d-qb__sg" data-sg-toggle aria-expanded="${!!state.sg}">${ICON_RULER}Guia de medidas</button>` : '';
        const sgBox = sizeOpt && state.sg ? `<div class="d-qb__sgbox">${SG.table(guide, state.sel[i])}${SG.NOTE}</div>` : '';
        return `<div class="d-qb__opt"><div class="d-qb__opt-head"><span>${esc(o.name)}</span>${sgBtn}<b>${esc(state.sel[i])}</b></div><div class="d-qb__vals">${vals}</div>${sgBox}</div>`;
      }).join('');
      const can = v && v.available;
      const label = !v ? 'Indisponível' : !v.available ? 'Esgotado' : EXTERNAL ? 'Adicionar e ir ao carrinho' : 'Adicionar ao carrinho';
      const thumbs = p.images.length > 1 ? `<div class="d-qb__thumbs" role="group" aria-label="Fotos do produto">${p.images.slice(0, 6).map((src, n) =>
        `<button type="button" data-thumb="${esc(src)}" aria-label="Foto ${n + 1}" aria-pressed="${src === img}"><img src="${esc(imgW(src, 160))}" alt="" loading="lazy"></button>`).join('')}</div>` : '';
      body.innerHTML = `
        <div class="d-qb__media"><img src="${esc(imgW(img, 900))}" alt="${esc(p.title)}">${thumbs}</div>
        <div class="d-qb__info">
          <span class="d-qb__line">${esc(line)}${tech ? ' · Técnica ' + tech : ''}</span>
          <h2 class="d-qb__title" id="d-qb-title">${esc(name)}</h2>
          <div class="d-qb__price">${money(price)}${cmp > price ? `<s>${money(cmp)}</s>` : ''}</div>
          ${opts}
          <div class="d-qb__row">
            <div class="d-qb__qty" role="group" aria-label="Quantidade">
              <button type="button" data-qty="-1" aria-label="Diminuir">−</button><output aria-live="polite">${state.qty}</output><button type="button" data-qty="1" aria-label="Aumentar">+</button>
            </div>
            <button type="button" class="d-btn d-btn-accent d-qb__add" data-qb-add ${can && !state.busy ? '' : 'disabled'}>${state.busy ? 'Adicionando…' : label}</button>
          </div>
          <p class="d-qb__msg${state.ok ? ' is-ok' : ''}" role="status">${esc(state.msg)}</p>
          <a class="d-qb__more" href="${esc(withUtm(ROOT + p.url, 'quick-buy'))}">Ver detalhes do produto →</a>
        </div>`;
    };

    const add = async () => {
      const v = current();
      if (!v || !v.available || state.busy) return;
      const qty = state.qty;
      const fallback = () => { location.href = withUtm(`${ROOT}/cart/add?id=${v.id}&quantity=${qty}`, 'quick-buy'); };
      if (EXTERNAL) return fallback();
      state.busy = true; draw();
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer && typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map((s) => s.id) : [];
      try {
        const r = await fetch(`${ROOT}/cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: qty }], sections, sections_url: location.pathname }),
        });
        const j = await r.json();
        state.busy = false;
        if (!r.ok || j.status) { state.msg = j.description || j.message || 'Não foi possível adicionar este item.'; draw(); return; }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'duvi-quick-buy', productVariantId: v.id, cartData: j });
        }
        if (drawer && typeof drawer.renderContents === 'function' && j.sections) {
          close();
          drawer.classList.remove('is-empty'); // Dawn's product form does the same; otherwise the item list stays hidden
          drawer.renderContents(j);
        } else {
          location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      } catch (e) {
        fallback(); // cross-origin / offline preview: add through the storefront link instead
      }
    };

    return { open, close };
  })();
  window.DUVIQuickBuy = QB;

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-qb]');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    QB.open(t.dataset.qb, t);
  });

  // Add the trigger to every Dawn product card (collections, search, recommendations…)
  const enhanceCards = (scope) => {
    $$('.card-wrapper', scope).forEach((w) => {
      if (w.dataset.dqb) return;
      const a = w.querySelector('a[href*="/products/"]');
      const m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      const host = w.querySelector('.card__inner') || w.querySelector('.card');
      if (!m || !host) return;
      w.dataset.dqb = '1';
      host.insertAdjacentHTML('beforeend', triggerHTML(decodeURIComponent(m[1]), a.textContent.trim()));
    });
  };
  if (!CFG.noCardEnhance) {
    enhanceCards(document);
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; enhanceCards(document); SG.mount(document); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ================= Reveal ================= */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  const reveal = (node) => (io ? io.observe(node) : node.classList.add('is-in'));
  const initReveal = (scope) => $$('.d-reveal:not(.is-in)', scope).forEach(reveal);

  /* ================= Hero ================= */
  const initHero = (root) => {
    const img = $('[data-hero-img]', root);
    if (!img) return;
    const sw = $$('[data-src]', root);
    sw.forEach((b) => { const i = new Image(); i.src = b.dataset.src; });
    sw.forEach((b) => b.addEventListener('click', () => {
      sw.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      img.style.opacity = 0;
      setTimeout(() => {
        img.removeAttribute('srcset');
        img.src = b.dataset.src;
        img.alt = b.dataset.alt || img.alt;
        img.style.opacity = 1;
      }, 180);
    }));
  };

  /* ================= Vitrine ================= */
  const initShowcase = (root) => {
    const data = $('script[data-d-products]', root);
    const grid = $('[data-grid]', root);
    if (!data || !grid) return;
    let parsed;
    try { parsed = JSON.parse(data.textContent); } catch (e) { return; }
    const products = parsed.p || {};   // { handle: product }
    const tabs = parsed.t || [];       // [[handle, …], …] — tab 0 = destaques
    const step = +root.dataset.initial || 8;
    const more = $('[data-more]', root);
    let tab = 0, visible = step;

    const card = (p) => {
      const { name, line, tech, gsm } = parseTitle(p.t, p.ty);
      const has2 = p.i.length > 1;
      const sizes = '(max-width: 640px) 50vw, (max-width: 1080px) 33vw, 300px';
      const src = (s) => `src="${esc(imgW(s, 600))}" srcset="${esc(imgW(s, 360))} 360w, ${esc(imgW(s, 600))} 600w" sizes="${sizes}"`;
      const badges = [];
      if (p.c > p.p) badges.push(`<span class="d-badge d-badge--sale">-${Math.round((1 - p.p / p.c) * 100)}%</span>`);
      if (tech) badges.push(`<span class="d-badge">${tech}</span>`);
      if (gsm) badges.push(`<span class="d-badge">${gsm}g</span>`);
      if (!p.a) badges.push('<span class="d-badge">Esgotado</span>');
      const cols = (p.co || []).filter((c) => COLOR_HEX[c]);
      const dots = cols.slice(0, 4).map((c) => `<i style="background:${COLOR_HEX[c]}" title="${esc(c)}"></i>`).join('') + (cols.length > 4 ? `<em>+${cols.length - 4}</em>` : '');
      const from = p.x > p.p ? '<small>a partir de</small>' : '';
      return `<article class="d-card d-reveal${has2 ? ' has-alt' : ''}">
        <a class="d-card__link" href="${esc(withUtm(ROOT + p.u, 'vitrine'))}">
          <div class="d-card__media">
            <div class="d-badges">${badges.join('')}</div>
            ${has2 ? `<img class="d-card__img is-alt" ${src(p.i[1])} alt="" loading="lazy" decoding="async">` : ''}
            ${p.i[0] ? `<img class="d-card__img is-main" ${src(p.i[0])} alt="${esc(p.t)}" loading="lazy" decoding="async">` : ''}
          </div>
          <div class="d-card__body">
            <span class="d-card__line d-mono">${esc(line)}</span>
            <h3>${esc(name)}</h3>
            <div class="d-card__foot">
              <span class="d-price">${from}${money(p.p)}${p.c > p.p ? `<s>${money(p.c)}</s>` : ''}</span>
              <span class="d-dots" aria-hidden="true">${dots}</span>
            </div>
          </div>
        </a>
        ${p.a ? `<div class="d-card__qb">${triggerHTML(p.h, name)}</div>` : ''}
      </article>`;
    };

    const list = () => {
      const handles = tabs[tab] && tabs[tab].length ? tabs[tab] : Object.keys(products);
      return handles.map((h) => products[h]).filter(Boolean).sort((a, b) => b.a - a.a);
    };
    const render = () => {
      const items = list();
      grid.innerHTML = items.slice(0, visible).map(card).join('');
      $$('.d-card', grid).forEach((c) => {
        c.addEventListener('pointermove', (e) => {
          const r = c.querySelector('.d-card__media').getBoundingClientRect();
          c.style.setProperty('--mx', ((e.clientX - r.left) / r.width) * 100 + '%');
          c.style.setProperty('--my', ((e.clientY - r.top) / r.height) * 100 + '%');
        });
        reveal(c);
      });
      if (more) more.hidden = items.length <= visible;
    };
    $$('[data-tab]', root).forEach((b) => b.addEventListener('click', () => {
      $$('[data-tab]', root).forEach((x) => x.setAttribute('aria-selected', String(x === b)));
      tab = +b.dataset.tab; visible = step; render();
    }));
    if (more) more.addEventListener('click', () => { visible += step; render(); });
    render();
  };

  /* ================= Estúdio ================= */
  const MODELS = {
    oversized: { label: 'Oversized',
      body: 'M156 36 L84 50 L22 150 L70 178 L94 146 L94 350 Q200 356 306 350 L306 146 L330 178 L378 150 L316 50 L244 36',
      neckFront: 'C230 60 170 60 156 36', neckBack: 'C230 48 170 48 156 36',
      folds: 'M94 150 Q108 230 102 300 M306 150 Q292 230 298 300 M132 336 Q156 320 168 342 M60 160 L84 152',
      back: { x: 130, y: 98, w: 140, h: 176 }, front: { x: 222, y: 90, w: 52, h: 38 } },
    regular: { label: 'Regular',
      body: 'M150 40 L100 54 L44 118 L84 156 L108 134 L108 338 Q200 346 292 338 L292 134 L316 156 L356 118 L300 54 L250 40',
      neckFront: 'C235 64 165 64 150 40', neckBack: 'C232 52 168 52 150 40',
      folds: 'M108 140 Q120 220 114 290 M292 140 Q280 220 286 290 M140 324 Q160 310 172 330',
      back: { x: 138, y: 96, w: 124, h: 168 }, front: { x: 218, y: 90, w: 50, h: 36 } },
    babylook: { label: 'Baby Look',
      body: 'M160 44 L114 56 L76 102 L100 126 L120 114 C128 170 128 200 120 250 L116 332 Q200 342 284 332 L280 250 C272 200 272 170 280 114 L300 126 L324 102 L286 56 L240 44',
      neckFront: 'C228 70 172 70 160 44', neckBack: 'C226 56 174 56 160 44',
      folds: 'M128 150 Q138 195 130 240 M272 150 Q262 195 270 240',
      back: { x: 142, y: 100, w: 116, h: 142 }, front: { x: 212, y: 94, w: 46, h: 32 } },
    tank: { label: 'Regata',
      body: 'M158 34 L136 34 C136 104 116 128 96 136 L96 346 Q200 354 304 346 L304 136 C284 128 264 104 264 34 L242 34',
      neckFront: 'C232 96 168 96 158 34', neckBack: 'C230 62 170 62 158 34',
      folds: 'M110 160 Q122 240 114 300 M290 160 Q278 240 286 300',
      back: { x: 132, y: 122, w: 136, h: 160 }, front: { x: 214, y: 120, w: 48, h: 34 } },
  };
  const COLORS = [['Preta', '#141416'], ['Off-White', '#ECE6D8'], ['Branca', '#F7F7F5'], ['Caramelo', '#C68A55'], ['Verde Musgo', '#6F7350'], ['Marrom', '#5B4032'], ['Azul Marinho', '#1F2A44'], ['Vinho', '#6E1A2C']];
  const INKS = [['Branco', '#FFFFFF'], ['Preto', '#0B0B0D'], ['Violeta', '#8B6CFF'], ['Ciano', '#2EE6FF'], ['Laranja', '#FF7A1A']];
  const FONTS = {
    bold: { label: 'Bold', family: 'Archivo', weight: 900, stretch: '118%', upper: true, ls: '-0.02em', lh: 0.92 },
    tech: { label: 'Tech', family: 'JetBrains Mono', weight: 800, stretch: '100%', upper: true, ls: '0.02em', lh: 1.05 },
    street: { label: 'Street', family: 'Permanent Marker', weight: 400, stretch: '100%', upper: false, ls: '0', lh: 1.05 },
  };
  const NS = 'http://www.w3.org/2000/svg';
  const lum = (hex) => { const n = parseInt(hex.slice(1), 16); return (0.299 * (n >> 16 & 255) + 0.587 * (n >> 8 & 255) + 0.114 * (n & 255)) / 255; };

  const initStudio = (root) => {
    const svg = $('[data-shirt]', root);
    if (!svg) return;
    const wa = root.dataset.wa || '';
    const S = { model: 'oversized', color: 'Preta', ink: 'Branco', font: 'bold', tech: 'DTG', size: 'M', side: 'back', text: ($('[data-text]', root) || {}).value || '', img: null };
    const q = (s) => $(s, root);

    q('[data-group="color"]').innerHTML = COLORS.map(([n, h]) => `<button type="button" aria-pressed="${n === S.color}" data-v="${n}" style="background:${h}" aria-label="${n}" title="${n}"></button>`).join('');
    q('[data-group="ink"]').innerHTML = INKS.map(([n, h]) => `<button type="button" aria-pressed="${n === S.ink}" data-v="${n}" style="background:${h}" aria-label="Tinta ${n}" title="Tinta ${n}"></button>`).join('');

    const wrapLines = (text, maxChars) => {
      const words = text.trim().split(/\s+/).filter(Boolean);
      const lines = []; let cur = '';
      words.forEach((w) => {
        if (!cur) cur = w;
        else if ((cur + ' ' + w).length <= maxChars) cur += ' ' + w;
        else { lines.push(cur); cur = w; }
      });
      if (cur) lines.push(cur);
      return lines.slice(0, 4);
    };

    const draw = () => {
      const m = MODELS[S.model];
      const hex = COLORS.find((c) => c[0] === S.color)[1];
      const neckCurve = S.side === 'front' ? m.neckFront : m.neckBack;
      const d = m.body + ' ' + neckCurve + ' Z';
      const neck = 'M' + m.body.split(' ').slice(-2).join(' ').replace(/^L/, '') + ' ' + neckCurve;
      ['[data-p="body"]', '[data-p="shade"]', '[data-p="ctr"]', '[data-p="outline"]'].forEach((s) => q(s).setAttribute('d', d));
      q('[data-p="body"]').setAttribute('fill', hex);
      q('[data-p="folds"]').setAttribute('d', m.folds);
      q('[data-p="collar"]').setAttribute('d', neck);
      q('[data-p="collar"]').setAttribute('stroke', lum(hex) > 0.5 ? 'rgba(0,0,0,.14)' : 'rgba(255,255,255,.08)');
      q('[data-p="outline"]').setAttribute('stroke-opacity', lum(hex) > 0.5 ? '0' : '.12');

      const a = S.side === 'front' ? m.front : m.back;
      const g = q('[data-p="guide"]');
      ['x', 'y'].forEach((k) => g.setAttribute(k, a[k]));
      g.setAttribute('width', a.w); g.setAttribute('height', a.h);
      const gl = q('[data-p="guide-label"]');
      gl.setAttribute('x', a.x); gl.setAttribute('y', a.y - 6);
      gl.style.display = S.side === 'front' ? 'none' : '';
      const cr = q('[data-p="clip"]');
      ['x', 'y'].forEach((k) => cr.setAttribute(k, a[k]));
      cr.setAttribute('width', a.w); cr.setAttribute('height', a.h);

      let ink = INKS.find((i) => i[0] === S.ink)[1];
      if (Math.abs(lum(ink) - lum(hex)) < 0.12) ink = lum(hex) > 0.5 ? '#0B0B0D' : '#FFFFFF';
      const pad = a.w * 0.06;
      let top = a.y + pad, th = a.h - pad * 2;
      const im = q('[data-p="img"]');
      if (S.img) {
        const ih = S.text.trim() ? a.h * 0.62 : a.h - pad * 2;
        im.setAttribute('href', S.img);
        im.setAttribute('x', a.x + pad); im.setAttribute('y', a.y + pad);
        im.setAttribute('width', a.w - pad * 2); im.setAttribute('height', ih);
        top = a.y + pad + ih + pad * 0.6; th = a.y + a.h - pad - top;
      } else {
        im.setAttribute('href', ''); im.setAttribute('width', 0); im.setAttribute('height', 0);
      }
      const tg = q('[data-p="text"]');
      tg.textContent = '';
      const f = FONTS[S.font];
      const raw = S.text.trim();
      if (raw && th > 4) {
        const txt = f.upper ? raw.toUpperCase() : raw;
        const lines = wrapLines(txt, S.side === 'front' ? 10 : (S.font === 'tech' ? 11 : 12));
        const base = 100;
        const els = lines.map((ln) => {
          const t = document.createElementNS(NS, 'text');
          t.textContent = ln;
          t.setAttribute('font-family', f.family);
          t.setAttribute('font-weight', f.weight);
          t.setAttribute('font-size', base);
          t.setAttribute('text-anchor', 'middle');
          t.setAttribute('fill', ink);
          t.style.fontStretch = f.stretch;
          t.style.letterSpacing = f.ls;
          tg.appendChild(t);
          return t;
        });
        let maxW = 1;
        els.forEach((t) => { try { maxW = Math.max(maxW, t.getComputedTextLength()); } catch (e) { /* not rendered yet */ } });
        const fs = Math.min(base * Math.min((a.w - pad * 2) / maxW, th / (lines.length * base * f.lh)), S.side === 'front' ? 18 : 64);
        const startY = top + (th - lines.length * fs * f.lh) / 2 + fs * 0.82;
        els.forEach((t, i) => {
          t.setAttribute('font-size', fs.toFixed(2));
          t.setAttribute('x', a.x + a.w / 2);
          t.setAttribute('y', (startY + i * fs * f.lh).toFixed(2));
        });
      }

      q('[data-v-label="model"]').textContent = m.label;
      q('[data-v-label="color"]').textContent = S.color;
      q('[data-v-label="style"]').textContent = FONTS[S.font].label + ' · ' + S.ink;
      q('[data-v-label="size"]').textContent = S.size;
      q('[data-hud="model"]').textContent = m.label + ' · ' + S.color;
      q('[data-hud="tech"]').textContent = S.tech + ' · ' + (S.side === 'front' ? 'Frente' : 'Costas');
      const msg = [
        'Oi! Quero personalizar uma peça na DUVI 👕', '',
        `• Modelo: ${m.label}`,
        `• Cor da peça: ${S.color}`,
        `• Estampa: ${raw ? '"' + raw + '"' : '(sem texto)'} — fonte ${FONTS[S.font].label}, tinta ${S.ink}`,
        `• Posição: ${S.side === 'front' ? 'Frente (peito)' : 'Costas (grande)'}`,
        `• Técnica: ${S.tech}`,
        `• Tamanho: ${S.size}`,
      ];
      if (S.img) msg.push('• Tenho uma imagem/arte para enviar aqui na conversa');
      msg.push('', 'Montei no Estúdio DUVI.');
      q('[data-send]').href = `https://wa.me/${wa}?text=${encodeURIComponent(msg.join('\n'))}`;
    };

    $$('[data-group]', root).forEach((group) => group.addEventListener('click', (e) => {
      const b = e.target.closest('button[data-v]');
      if (!b) return;
      $$('button[data-v]', group).forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      S[group.dataset.group] = b.dataset.v;
      draw();
    }));
    $$('[data-side]', root).forEach((b) => b.addEventListener('click', () => {
      $$('[data-side]', root).forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      S.side = b.dataset.side; draw();
    }));
    const txt = q('[data-text]'), cnt = q('[data-count]');
    txt.addEventListener('input', () => { S.text = txt.value; cnt.textContent = `${txt.value.length}/40`; draw(); });
    const file = q('[data-file]'), up = q('[data-upload]'), upName = q('[data-upload-name]'), upDefault = upName.textContent;
    file.addEventListener('change', () => {
      const f = file.files && file.files[0];
      if (!f || !f.type.startsWith('image/')) return;
      const r = new FileReader();
      r.onload = () => { S.img = r.result; up.classList.add('has-file'); upName.textContent = f.name; draw(); };
      r.readAsDataURL(f);
    });
    q('[data-remove]').addEventListener('click', (e) => {
      e.preventDefault(); e.stopPropagation();
      S.img = null; file.value = ''; up.classList.remove('has-file'); upName.textContent = upDefault; draw();
    });
    draw();
    if (document.fonts) {
      document.fonts.ready.then(draw);
      Promise.all(['900 20px Archivo', '800 20px "JetBrains Mono"', '20px "Permanent Marker"'].map((f) => document.fonts.load(f))).then(draw).catch(() => {});
    }
  };

  /* ================= Boot (and re-boot inside the theme editor) ================= */
  const boot = (scope) => {
    initReveal(scope);
    $$('[data-d-hero]', scope).forEach(initHero);
    $$('[data-d-showcase]', scope).forEach(initShowcase);
    $$('[data-d-studio]', scope).forEach(initStudio);
  };
  boot(document);
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
